import hamburger from './modules/hamburger';
import loading from './modules/loading';
import keyvisual from './modules/keyvisual';
import stickyPC from './modules/stickyPC';
import sticky from './modules/sticky';
import fadeIn from './modules/fadeIn';
import confirm from './modules/confirm';
import errorHighlight from './modules/errorHighlight';

const slug = document.querySelector('body');
if (slug.classList.contains('front')) {
  loading();

  keyvisual();

  if (window.matchMedia('(max-width: 768px)').matches) {
    sticky();
  } else {
    stickyPC();
  }
} else if (slug.classList.contains('contact')) {
  errorHighlight();
} else if (slug.classList.contains('confirm')) {
  confirm();
}

if (!slug.classList.contains('front')) {
  sticky();
}

fadeIn();

if (window.matchMedia('(max-width: 768px)').matches) {
  hamburger();
}

const form = document.querySelector('.mw_wp_form form');

if (form) {
  form.classList.add('h-adr');
}
